import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Frame');
const Frame = _ref => {
  let {
    url
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("iframe", {
    className: classes.root,
    title: "Marketing banner",
    scrolling: "no",
    src: url
  });
};
export default /*#__PURE__*/memo(Frame);